import { createContext } from 'react';

const context = createContext({
  value: '',
  onChange: () => {},
});

const { Provider, Consumer } = context;

export { Provider, Consumer };
